import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uk-card-body" }
const _hoisted_2 = {
  key: 0,
  class: "uk-grid"
}
const _hoisted_3 = { class: "uk-width-1-3" }
const _hoisted_4 = { class: "uk-width-1-3" }
const _hoisted_5 = {
  key: 0,
  for: "eta",
  class: "uk-form-label"
}
const _hoisted_6 = {
  key: 1,
  for: "eta",
  class: "uk-form-label"
}
const _hoisted_7 = {
  key: 1,
  class: "uk-grid"
}
const _hoisted_8 = { class: "uk-width-1-4" }
const _hoisted_9 = { class: "uk-width-1-4" }
const _hoisted_10 = { class: "uk-width-1-4" }
const _hoisted_11 = { class: "uk-width-1-4" }
const _hoisted_12 = {
  key: 2,
  class: "uk-grid uk-margin-small-top"
}
const _hoisted_13 = { class: "uk-width-1-3" }
const _hoisted_14 = { class: "uk-width-1-3" }
const _hoisted_15 = { class: "uk-width-1-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_InputField = _resolveComponent("InputField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showBrokerFields)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              for: "ship line",
              class: "uk-form-label"
            }, "Steamship Line", -1)),
            _createVNode(_component_FilterableDropdown, {
              taggable: "",
              "push-tag": "",
              modelValue: _ctx.orderData.shipLineInfo.line,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderData.shipLineInfo.line) = $event)),
              options: _ctx.steamshipLines,
              components: { OpenIndicator: null, Deselect: null }
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "blNumber",
              class: "uk-form-label"
            }, "Vessel Name", -1)),
            _createVNode(_component_FilterableDropdown, {
              taggable: "",
              "push-tag": "",
              modelValue: _ctx.orderData.shipLineInfo.vessel,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderData.shipLineInfo.vessel) = $event)),
              options: _ctx.filteredVessels,
              components: { OpenIndicator: null, Deselect: null }
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", null, [
            (_ctx.isOceanImport)
              ? (_openBlock(), _createElementBlock("label", _hoisted_5, "ETA"))
              : (_openBlock(), _createElementBlock("label", _hoisted_6, "Vessel Cut Off/LRD")),
            _createVNode(_component_DatePicker, {
              class: "uk-form-label",
              "input-class": 'uk-input uk-width-medium',
              format: "MM/DD/YYYY",
              onInput: _ctx.changedETA
            }, null, 8, ["onInput"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showBrokerFields)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_InputField, {
              label: "Port of Loading",
              modelValue: _ctx.orderData.brokerSailingInfo.portOfLoading,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.portOfLoading) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_InputField, {
              label: "Port of Discharge",
              modelValue: _ctx.orderData.brokerSailingInfo.portOfDischarge,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.portOfDischarge) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputField, {
              label: "Place of Receipt",
              modelValue: _ctx.orderData.brokerSailingInfo.placeOfReceipt,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.placeOfReceipt) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_InputField, {
              label: "Place of Delivery",
              modelValue: _ctx.orderData.brokerSailingInfo.placeOfDelivery,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.placeOfDelivery) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showBrokerFields)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_InputField, {
              label: "Vessel/Voyage",
              modelValue: _ctx.orderData.brokerSailingInfo.vesselVoyage,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.vesselVoyage) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_InputField, {
              label: "Sailing Date",
              modelValue: _ctx.orderData.brokerSailingInfo.sailingDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.sailingDate) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_InputField, {
              label: "Arrival Date",
              modelValue: _ctx.orderData.brokerSailingInfo.arrivalDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.orderData.brokerSailingInfo.arrivalDate) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}